import { useState } from "react";
// react-router-dom components
import { Link, useLocation } from "react-router-dom";
// @mui material components
import Card from "@mui/material/Card";
//import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
// layout components
import LogoutPageLayout from "layouts/logoutpage/LogoutPageLayout.js";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useForm } from 'react-hook-form';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import Config from "../../config.js";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import configurationContext from "contextConfig";

function RecoverPassword() {
  const { t } = useTranslation();
  const MyContext = useContext(configurationContext);
  const BASE = Config.BASE;
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    watch,
    formState: { errors }
  } = useForm();


  const setValueFn = (setValueData) => {
    setValue('email', setValueData.email);
    setValue('newPassword', setValueData.newPassword);
    setValue('confirmPassword', setValueData.confirmPassword);
  }

  const onSubmit = async (data) => {
    setIsLoading(true);
    await axios({
      // Endpoint to send files
      url: BASE + "api/forgotPasswordConfirm",
      method: "POST",
      data: { email: data.email, newPassword: data.newPassword, confirmPassword: data.confirmPassword, token: params.get('token'), expiry: params.get('expiry') },
      headers: {
        // Add any auth token here
        authorization: "no-token",
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then((response) => {
      (response.status == 200 && response.data.status == 1) ?
        (
          toast.success(t(response.data.message))
        ) : (response.status == 200 && response.data.status == 0) ?
          (
            toast.error(t(response.data.message)), setValue('email', ''), setValue('newPassword', ''), setValue('confirmPassword', '')
          ) :
          (
            toast.error('unexpected error')
          );
      setIsLoading(false);
    }).catch((error) => {
      setIsLoading(false);
    });
  };

  return (
    <LogoutPageLayout image={bgImage}>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center"        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>Reset Password</MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {(isLoading) ?
            <CircularProgress />
            : null
          }
          <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
            <MDBox mb={2}>
              <MDInput type="email" name="email" label="Email" {...register("email", { required: true, pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/ })} fullWidth />
              {errors.email && errors.email.type === "required" && (
                <p className="errorMsg">{t('emailRequired')}</p>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <p className="errorMsg">{t('email is not valid')}</p>
              )}
              {errors.email && (
                <p className="errorMsg">{t(errors.email.message)}</p>
              )}
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" name="newPassword" label="New Password" {...register("newPassword", {
                required: true,
                minLength: 6
              })} fullWidth />
              {errors.newPassword && errors.newPassword.type === "required" && (
                <p className="errorMsg">{t('passwordRequired')}</p>
              )}
              {errors.newPassword && (
                <p className="errorMsg">{t(errors.newPassword.message)}</p>
              )}
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" name="confirmPassword" label="Confirm Password" {...register("confirmPassword", {
                required: true,
                minLength: 6, validate: (value) => {
                  if (watch('newPassword') != value) {
                    return ('passwordMatching');
                  }
                }
              })} fullWidth />
              {errors.confirmPassword && errors.confirmPassword.type === "required" && (
                <p className="errorMsg">{t('confirm passwordRequired')}</p>
              )}
              {errors.confirmPassword && errors.confirmPassword.type === "minLength" && (
                <p className="errorMsg">
                  {t('password length message', { length: MyContext.minPasswordLength })}
                </p>
              )}
              {errors.confirmPassword && (
                <p className="errorMsg">{t(errors.confirmPassword.message)}</p>
              )}
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" disableRipple fullWidth>{t('reset')}</MDButton>
            </MDBox>
          </MDBox>
          <MDBox mt={3} mb={1} textAlign="center">
            <MDTypography variant="button" color="text">
              {t('Forgot Password')}? {" "}
              <MDTypography
                component={Link}
                to="/admin/forgotpassword"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                {t('click here')}
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
      <ToastContainer position="top-center" />
    </LogoutPageLayout>
  );
}
export default RecoverPassword;
